export const MED_SEARCH_REQUEST = "MED_SEARCH_REQUEST";
export const MED_SEARCH_SUCCESS = "MED_SEARCH_SUCCESS";
export const MED_SEARCH_FAIL = "MED_SEARCH_FAIL";

export const LOWSTOCK_REQUEST = "LOWSTOCK_REQUEST";
export const LOWSTOCK_SUCCESS = "LOWSTOCK_SUCCESS";
export const LOWSTOCK_FAIL = "LOWSTOCK_FAIL";

export const SALE_REQUEST = "SALE_REQUEST";
export const SALE_SUCCESS = "SALE_SUCCESS";
export const SALE_FAIL = "SALE_FAIL";

export const PRESCRIPTION_REQUEST = "PRESCRIPTION_REQUEST";
export const PRESCRIPTION_SUCCESS = "PRESCRIPTION_SUCCESS";
export const PRESCRIPTION_FAIL = "PRESCRIPTION_FAIL";
export const PRESCRIPTION_CLEAR = "PRESCRIPTION_CLEAR";
